<template>
  <div v-if="show" class="personal-page-wrapper" :class="rootLayoutClass">
    <MobilePage :personalInfo="personalInfo"></MobilePage>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import MobilePage from './homeLayout.vue'
import { deviceType } from '@/utils/common'
import { ACCOUNT_TYPE } from '@/constant/common'
export default {
  components: {
    MobilePage
  },
  data () {
    return {
      show: false,
      personalInfo: { name: '', employee: null }
    }
  },
  computed: {
    ...mapGetters('account', ['getCurrentAccount']),
    currentAccount () {
      return this.getCurrentAccount
    },
    isPc () {
      return deviceType.isPc
    },
    rootLayoutClass () {
      if (this.$route.meta.rootLayout) {
        const layoutSetting = this.$route.meta.rootLayout
        return [
          layoutSetting.hiddenPageMenu && 'hidden-page-menu',
          layoutSetting.hiddenPageHeader && 'hidden-page-header'
        ]
      }
      return null
    },
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
    if (!this.currentAccount?.id) {
      const companyId = this.$route.query.company_id
      this.$router.push({ path: `/passport/${ACCOUNT_TYPE.CANDIDATE}/register/`, query: { back: this.$route.fullPath, company_id: companyId } })
      return
    }
    this.initData()
  },
  methods: {
    ...mapActions('personal', ['getPersonalInfo', 'activePersonalEmployee']),
    async initData () {
      this.show = false
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.getPersonalInfo({ company_id: this.companyId })
        if (resp) {
          if (resp.need_create_password) {
            return this.$router.push({ path: `/passport/candidate/create-password/${resp.password_reset_code}/`, query: { back: this.$route.fullPath } })
          }
          this.personalInfo = resp
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
        this.show = true
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-page-wrapper {
  &.hidden-page-menu {
    ::v-deep {
      .page-body {
        background-color: #fff;

        .page-menu {
          display: none;
        }
      }
    }
  }

  &.hidden-page-header {
    ::v-deep .page-header {
      display: none;
    }
  }
}
</style>
